import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { ShowleftDirective } from '../../../directives/animations/showleft.directive';

@Component({
  selector: 'section[app-home-designed-details]',
  imports: [NgOptimizedImage, ShowleftDirective],
  templateUrl: './home-designed-details.html',
  styleUrl: './home-designed-details.scss',
})
export class HomeDesignedDetails {

}
